<h1 class="center" *ngIf="displayHeader | async">
    Gestion au quotidien
</h1>
<nav *ngIf="displayHeader | async">
    <a routerLinkActive="active-link" routerLink="./vt">Vêtement de travail</a>
    <a routerLinkActive="active-link" routerLink="./lp">Linge plat</a>
</nav>
<router-outlet></router-outlet>